import axios from 'axios';

const baseUrl = process.env.REACT_APP_BACKEND_DOMAIN;

export default class PointsBoost {
  static endpoints = {
    index: `${baseUrl}/points-boosts`,
  };

  static async getBoost() {
    return axios.get(this.endpoints.index).then(response => response.data.booster);
  }

  static async getActiveBoost() {
    return axios.get(`${this.endpoints.index}/active-booster`).then(response => response.data.activeBooster);
  }

  static async activateBooster() {
    return axios.post(`${this.endpoints.index}/claim-booster`).then(response => response.data.activatedBooster);
  }
}